import React, { Suspense, lazy } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { BuilderPage } from "./pages/BuilderPage";
import { MyPage } from "./pages/MyPage";
import { DashboardPage } from "./pages/dashboard/DashboardPage";

// Master
import { RDetailPage } from "./pages/master/r-detail/RDetailPage";
import { RHHeaderPage } from "./pages/master/rh-header/RHHeaderPage";
import { RHDetailPage } from "./pages/master/rh-detail/RHDetailPage";
import { KCabangPage } from "./pages/master/k-cabang/KCabangPage";
import { AltUOMPage } from "./pages/master/alt-uom/AltUOMPage";
import { PlantPage } from "./pages/master/plant/PlantPage";
import { CRPRGPPage } from "./pages/master/crprgp/CRPRGPPage";
// invoiceOld
import { InvoiceOldDetail } from "./pages/master/sap-invoice-old/InvoiceOldDetail";
import { SapInvoiceOldPage } from "./pages/master/sap-invoice-old/SapInvoiceOldPage";
// tax old
import { TaxOldDetail } from "./pages/master/sap-tax-old/TaxOldDetail";
import { TaxOldPage } from "./pages/master/sap-tax-old/TaxOldPage";
import { CustomerPage } from "./pages/master/customer/CustomerPage";
// report header
import { ReportHeaderPage } from "./pages/report-return/report-header/ReportHeaderPage";
import { ReportHeaderDetail } from "./pages/report-return/report-header/ReportHeaderDetail";
// report detail
import { ReportDetailPage } from "./pages/report-return/report-detail/ReportDetailPage";
import { ReportDetail } from "./pages/report-return/report-detail/ReportDetail";

// RTV
// import WithoutRTVPageLama from "./pages/new-return/without-rtv/WithoutRTVPageLama";
// import NonMTKADetailsLama from "./pages/new-return/without-rtv/NonMTKADetailsLama";
import { NonReferencePage } from "./pages/new-return/without-rtv/non-reference/NonReferencePage";
import { DraftNonRef } from "./pages/new-return/without-rtv/non-reference/DraftNonRef";

// WithRTV
import { WithRtvPage } from "./pages/new-return/with-rtv/WithRtvPage";
import { WithRtvCreate } from "./pages/new-return/with-rtv/WithRtvCreate";
import { WithRtvDetail } from "./pages/new-return/with-rtv/WithRtvDetail";
import { WithRtvNonRefDetail } from "./pages/new-return/with-rtv/WithRtvNonRefDetail";

// FSS
import { FssPage } from "./pages/fss-asm-bm/FssPage";
import { FssApproval } from "./pages/fss-asm-bm/FssApproval";
import { FssDetail } from "./pages/fss-asm-bm/FssDetail";

// BRQA
import { BrqaPage } from "./pages/brqa/BrqaPage";
import { BrqaApproval } from "./pages/brqa/BrqaApproval";
import { BrqaDetail } from "./pages/brqa/BrqaDetail";

// QAHO
import { QahoPage } from "./pages/qaho/QahoPage";
import { QahoDetail } from "./pages/qaho/QahoDetail";
import { QahoApproval } from "./pages/qaho/QahoApproval";

// CLIENT
import { ClientPage } from "./pages/client/ClientPage";
import { ClientApproval } from "./pages/client/ClientApproval";
import { ClientDetail } from "./pages/client/ClientDetail";
// CD
import { DeliveryPage } from "./pages/chief-delivery/DeliveryPage";
import { DeliveryDetail } from "./pages/chief-delivery/DeliveryDetail";
// import PdfViewer from "./pages/chief-delivery/PdfViewer";

// Chief Warehouse
import { WarehousePage } from "./pages/chief-warehouse/WarehousePage";
import { WarehouseDetail } from "./pages/chief-warehouse/WarehouseDetail";

// Reject
import { RejectPage } from "./pages/reject-return/RejectPage";
import { RejectDetail } from "./pages/reject-return/RejectDetail";
import { RejectBackCustomer } from "./pages/reject-return/RejectBackCustomer";

// new withourRTV
import { WithoutRtvPage } from "./pages/new-return/without-rtv/reference/WithoutRtvPage";
import { WithoutRtvDetail } from "./pages/new-return/without-rtv/reference/WithoutRtvDetail";

// approval change
import { ApprovalChangePage } from "./pages/report-return/approval-changes/ApprovalChangesPage";
import { WithRtvDetailDraft } from "./pages/new-return/with-rtv/WithRtvDetailDraft";

const ECommercePage = lazy(() =>
  import("./modules/ECommerce/pages/eCommercePage")
);
const UserProfilepage = lazy(() =>
  import("./modules/UserProfile/UserProfilePage")
);
const AdministratorPage = lazy(() =>
  import("./pages/administrator/AdministratorPage")
);

export default function BasePage() {
  // useEffect(() => {
  //   console.log('Base page');
  // }, []) // [] - is required if you need only one call
  // https://reactjs.org/docs/hooks-reference.html#useeffect

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/dashboard" />
        }
        <ContentRoute path="/dashboard" component={DashboardPage} />
        <ContentRoute path="/builder" component={BuilderPage} />
        <ContentRoute path="/my-page" component={MyPage} />
        <ContentRoute path="/setting" component={BuilderPage} />
        {/* admin */}
        <Route path="/administrator" component={AdministratorPage} />

        {/* master */}
        <ContentRoute path="/master/r-detail" component={RDetailPage} />
        <ContentRoute path="/master/rh-header" component={RHHeaderPage} />
        <ContentRoute path="/master/rh-detail" component={RHDetailPage} />
        <ContentRoute path="/master/k-cabang" component={KCabangPage} />
        <ContentRoute path="/master/alt-uom" component={AltUOMPage} />
        <ContentRoute path="/master/plant" component={PlantPage} />
        <ContentRoute path="/master/crprgp" component={CRPRGPPage} />
        <ContentRoute
          path="/master/sap-invoice-old/detail-data"
          component={InvoiceOldDetail}
        />
        <ContentRoute
          path="/master/sap-invoice-old"
          component={SapInvoiceOldPage}
        />
        <ContentRoute
          path="/master/sap-tax-old/detail-data"
          component={TaxOldDetail}
        />
        <ContentRoute path="/master/sap-tax-old" component={TaxOldPage} />
        <ContentRoute path="/master/customer" component={CustomerPage} />

        {/* report header */}
        <ContentRoute
          path="/report-return/report-header/detail/:id"
          component={ReportHeaderDetail}
        />
        <ContentRoute
          path="/report-return/report-header/:id"
          component={ReportHeaderPage}
        />
        <ContentRoute
          path="/report-return/report-header"
          component={ReportHeaderPage}
        />
        {/* report header */}
        <ContentRoute
          path="/report-return/report-detail/detail/:id"
          component={ReportDetail}
        />
        <ContentRoute
          path="/report-return/report-detail/detail"
          component={ReportDetail}
        />
        <ContentRoute
          path="/report-return/report-detail/:id"
          component={ReportDetailPage}
        />
        <ContentRoute
          path="/report-return/report-detail"
          component={ReportDetailPage}
        />

        <ContentRoute
          path="/report-return/approval-changes"
          component={ApprovalChangePage}
        />

        {/* WithRtv */}
        <ContentRoute
          path="/new-return/with-rtv/draft/detail"
          component={WithRtvDetailDraft}
        />
        <ContentRoute
          path="/new-return/with-rtv/detail"
          component={WithRtvDetail}
        />
        <ContentRoute
          path="/new-return/with-rtv/non-ref"
          component={WithRtvNonRefDetail}
        />
        <ContentRoute
          path="/new-return/with-rtv/list"
          component={WithRtvPage}
        />
        <ContentRoute path="/new-return/with-rtv" component={WithRtvCreate} />

        {/* with outRTV */}
        <ContentRoute
          path="/new-return/non-rtv/non-reference-draft"
          component={DraftNonRef}
        />
        <ContentRoute
          path="/new-return/non-rtv/non-reference"
          component={NonReferencePage}
        />
        <ContentRoute
          path="/new-return/non-rtv/non-rtv-detail/:id"
          component={WithoutRtvDetail}
        />
        <ContentRoute
          path="/new-return/non-rtv/non-rtv-detail/"
          component={WithoutRtvDetail}
        />
        <ContentRoute path="/new-return/non-rtv" component={WithoutRtvPage} />

        {/* FSS/ASM/BM */}
        <ContentRoute path="/fss-asm-bm/sales-detail" component={FssApproval} />
        <ContentRoute path="/fss-asm-bm/detail-data" component={FssDetail} />
        <ContentRoute path="/fss-asm-bm/:id" component={FssPage} />
        <ContentRoute path="/fss-asm-bm" component={FssPage} />
        {/* BRQA */}
        <ContentRoute path="/brqa/brqa-detail" component={BrqaApproval} />
        <ContentRoute path="/brqa/detail-data" component={BrqaDetail} />
        <ContentRoute path="/brqa/:id" component={BrqaPage} />
        <ContentRoute path="/brqa" component={BrqaPage} />

        {/* QAHO */}
        <ContentRoute path="/qa-ho/qaho-detail" component={QahoApproval} />
        <ContentRoute path="/qa-ho/detail-data" component={QahoDetail} />
        <ContentRoute path="/qa-ho/:id" component={QahoPage} />
        <ContentRoute path="/qa-ho" component={QahoPage} />
        {/* CLIENT */}
        <ContentRoute path="/client/client-detail" component={ClientApproval} />
        <ContentRoute path="/client/detail-data" component={ClientDetail} />
        <ContentRoute path="/client/:id" component={ClientPage} />
        <ContentRoute path="/client" component={ClientPage} />
        {/* CD */}

        <ContentRoute
          path="/chief-delivery/delivery-detail"
          component={DeliveryDetail}
        />
        <ContentRoute path="/chief-delivery/:id" component={DeliveryPage} />
        <ContentRoute path="/chief-delivery" component={DeliveryPage} />
        {/* Chief Warehouse */}
        <ContentRoute
          path="/chief-warehouse/warehouse-detail"
          component={WarehouseDetail}
        />
        <ContentRoute path="/chief-warehouse/:id" component={WarehousePage} />
        <ContentRoute path="/chief-warehouse" component={WarehousePage} />

        {/* Reject */}
        <ContentRoute
          path="/reject-return/detail-new"
          component={RejectDetail}
        />
        <ContentRoute
          path="/reject-return/back-customer"
          component={RejectBackCustomer}
        />
        <ContentRoute path="/reject-return" component={RejectPage} />

        <Route path="/e-commerce" component={ECommercePage} />
        <Route path="/user-profile" component={UserProfilepage} />
        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
